import { defaultStateBudgetState } from './module-statebudget-state';

export default {
	resetState(state) {
		//Object.assign(state, defaultAuthState);
	},
	updateStateBudgets(state, res) {
		state.StateBudgets.removeAll();
		state.StateBudgets.append(res.Data.Data);
		state.Total = res.Data.Total;
	},
	updateStateBudgetsLoaded(state, data) {
		state.StateBudgetsLoaded = data;
	}
};
